// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ArticleGridItemFragmentDoc } from './article-grid/ArticleGridItem.fragment.generated';
export const ComponentArticleGridFragmentDoc = gql`
    fragment componentArticleGrid on ComponentArticleGrid {
  articles(locale: $locale) {
    ...articleGridItem
  }
}
    ${ArticleGridItemFragmentDoc}`;